module.exports = __webpack_public_path__ + "static/media/upload-arrow-up-svgrepo-com.f8183410.svg";